// extracted by mini-css-extract-plugin
export default {"about_section":"style_about_section__12vIH","title":"style_title__tjYYh","content":"style_content__KCq6U"};